export const DND_CREATABLE_ID = "creatable";
export const DND_TEMPLATE_ID = "template";
export const DND_DROPPABLE_ID = "droppable";
export const DND_LAYER_ID = "layer";
export const DND_SORTABLE_ID = "sortable";
export const DND_RESIZEABLE_ID = "resizeable";
export const DND_TRANSFORM_ORIGIN_ID = "transform-origin-handle";

export const DND_CANVAS_SIDEBAR_LAYERS_ID = "canvasSidebarLayers";
export const DND_CANVAS_SIDEBAR_ID = "canvasSidebar";
export const DND_CANVAS_EDITOR_ID = "canvasEditor";
export const DND_CANVAS_BACKGROUND_ID = "canvasBackground";
export const DND_CANVAS_ID = "canvas";
